import BeautyForm from "@/components/BeautyForm";
import { usePageViewTracking } from "@/hooks/usePageViewTracking";
import { TRACKED_STEPS } from "@/config/tracking";

const Index = () => {
  usePageViewTracking(TRACKED_STEPS.form);
  return <BeautyForm />;
};

export default Index;
